var map = {
	"./50_dog.mp3": "1c96",
	"./51_cat.mp3": "d796",
	"./52_mouse.mp3": "a977",
	"./53_fish.mp3": "c079",
	"./54_hamster.mp3": "3ada",
	"./55_parrot.mp3": "c7c6",
	"./56_canary.mp3": "5b19",
	"./click.mp3": "33f3",
	"./empty_true.mp3": "f6de",
	"./false.mp3": "093f",
	"./true.mp3": "1c1a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0092";